import { useEffect, useState } from "react";

import Container from "react-bootstrap/Container";
import { toast } from "react-toastify";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Table from "../../components/Table";
import {
  createRosterCode,
  deleteRosterCode,
  getRosterCodes,
} from "../../services/RosterCodeService";
import { ReactComponent as CopyClipboardIcon } from "../../static/icons/copy-clipboard.svg";
import PrimaryButton from "../../components/PrimaryButton";
import { ReactComponent as DeleteIcon } from "../../static/icons/delete-icon.svg";

const RosterCodeList = () => {
  const [rosterCodes, setRosterCodes] = useState([]);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(
        `${process.env.REACT_APP_DOMAIN}/employments?invite_code=${text}`
      );
      toast.success(
        "The link has been copied. Share it with an employer to be added as an employee."
      );
    } catch (err) {
      toast.error("Error while copying to clipboard.");
    }
  };

  const columns = [
    {
      label: "Code",
      name: "code",
    },
    {
      type: "button",
      name: "copy-btn",
      component: (item) => (
        <CopyClipboardIcon
          onClick={() => copyToClipboard(item.code)}
          style={{ cursor: "pointer", width: "18px" }}
        />
      ),
    },
    {
      type: "button",
      name: "delete-btn",
      component: (item) => (
        <a
          onClick={() =>
            deleteRosterCode({ codeId: item.id }).then(() => {
              setRosterCodes((oldVal) =>
                oldVal.filter((i) => i.id !== item.id)
              );
              toast.success("The code has been deleted.");
            })
          }
        >
          <DeleteIcon />
        </a>
      ),
    },
  ];

  useEffect(() => {
    getRosterCodes().then((data) => setRosterCodes(data));
  }, []);

  return (
    <Table
      columns={columns}
      data={rosterCodes}
      header={
        <Container style={{ margin: "13px 13px 25px" }}>
          <Row>
            <Col>
              <h5 className="vertical-align-text table-title">Invite codes: create + send to an employer for them start using ready.ninja</h5>
            </Col>
            <Col>
              <PrimaryButton
                onClick={() =>
                  createRosterCode().then((data) => {
                    toast.success("A code has been created.");
                    setRosterCodes((oldVal) => [...oldVal, data]);
                  })
                }
                style={{ float: "right" }}
              >
                Add +
              </PrimaryButton>
            </Col>
          </Row>
        </Container>
      }
    />
  );
};

export default RosterCodeList;
